import { createStore } from '@aibees/shared/store';
import { TableAccordionStoreData as StoreData } from './types';

const useTableAccordionStore = createStore<StoreData>(
  'table-accordion',
  (set, get) => ({
    expandedMap: {},

    setExpanded: (dialogId: string, accordionId: string | null) =>
      set((state) => ({
        expandedMap: {
          ...state.expandedMap,
          [dialogId]: accordionId,
        },
      })),

    getExpanded: (dialogId: string) => get().expandedMap[dialogId] || null,

    // Set initial expanded accordion for a dialog (only if not already set)
    setInitialExpanded: (dialogId: string, accordionId: string | null) => {
      const current = get().expandedMap[dialogId];
      if (current === undefined) {
        set((state) => ({
          expandedMap: {
            ...state.expandedMap,
            [dialogId]: accordionId,
          },
        }));
      }
    },

    // Clear dialog state when dialog closes
    clearDialog: (dialogId: string) =>
      set((state) => {
        const newExpandedMap = { ...state.expandedMap };
        delete newExpandedMap[dialogId];
        return { expandedMap: newExpandedMap };
      }),

    // Get expanded accordion for a specific dialog
    getDialogExpanded: (dialogId: string) =>
      get().expandedMap[dialogId] || null,

    // Set expanded accordion for a specific dialog with callback support
    setDialogExpanded: (
      dialogId: string,
      accordionId: string | null,
      onAccordionChange?: (accordionId: string | null) => void
    ) => {
      set((state) => ({
        expandedMap: {
          ...state.expandedMap,
          [dialogId]: accordionId,
        },
      }));
      onAccordionChange?.(accordionId);
    },
  })
);

export default useTableAccordionStore;
